import { AppDetailsPopover } from './AppDetailsPopover';
import { AppDisplay } from './AppDisplay';
import uniq from 'lodash/uniq';
import React, { useMemo } from 'react';
import { Space, SpaceProps } from 'antd';

export interface DirectionalAppListProps {
	direction: SpaceProps['direction'];
	ingestingAppIds: Array<number>;
	populatingAppIds: Array<number>;
}

export const DirectionalAppList: React.FC<DirectionalAppListProps> = ({
	direction,
	ingestingAppIds,
	populatingAppIds
}) => {
	const uniqueAppIds = useMemo(
		() => uniq(ingestingAppIds.concat(populatingAppIds)),
		[ ingestingAppIds, populatingAppIds ]
	);

	if (!uniqueAppIds.length) {
		return null;
	}

	return (
		<Space
			align='start'
			direction={ direction }
			size={ direction === 'horizontal' ? 0 : 4 }>
			{ uniqueAppIds.map((appId) =>
				<AppDetailsPopover
					appId={ appId }
					key={ appId }>
					<AppDisplay
						appId={ appId }
						key={ appId }
						read={ ingestingAppIds.includes(appId) }
						write={ populatingAppIds.includes(appId) } />
				</AppDetailsPopover>) }
		</Space>
	);
};
